export default __webpack_public_path__ + "static/media/delievers15.d2ed5f46.jpeg";